<template>
  <div>
    <div class="tm-sidebar-left scroller uk-dark uk-animation-slide-left-small uk-animation-fast">     
        <a class="back-button uk-link-text" v-on:click="$emit('sidebarClick', '')"><i class="material-icons">arrow_back</i></a>           
        <div class="uk-text-bold header">
            <span>Border</span>
            <span class="uk-text-muted uk-text-small uk-float-right"><i>BETA</i></span>
        </div> 

        <form>
            <ul uk-accordion="multiple: true">
                <li class="uk-open">
                    <a class="uk-accordion-title uk-text-muted" href="#">Type</a>
                    <div class="uk-accordion-content">
                        
                        <!-- Border Type Picker -->
                        <label class="uk-form-label" for="form-stacked-text">Choose Type:</label>
                        <div class="uk-flex uk-flex-center">
                            <a :class="['border-type', {'file-type-active': this.borderType === 'bottom'}]" @click="borderTypeChoosen('bottom')" uk-tooltip="title: Add border below image; pos: right; delay: 400;">
                            <div class="four-px-padding">
                                <img src="/img/illustrations/border_types/border-bottom.svg" width="70px">
                            </div>
                            </a>
                            <a :class="['border-type', {'file-type-active': this.borderType === 'top'}]" @click="borderTypeChoosen('top')" uk-tooltip="title: Add border on top of image; pos: right; delay: 400;">
                            <div class="four-px-padding">
                                <img src="/img/illustrations/border_types/border-top.svg" width="70px">
                            </div>
                            </a>
                            <a :class="['border-type', {'file-type-active': this.borderType === 'all-sides'}]" @click="borderTypeChoosen('all-sides')" uk-tooltip="title: Add border to all sides of image; pos: right; delay: 400;">
                            <div class="four-px-padding">
                                <img src="/img/illustrations/border_types/border-all.svg" width="70px">
                            </div>
                            </a>              
                        </div>
                        <div class="uk-flex uk-flex-center">
                            <a :class="['border-type', {'file-type-active': this.borderType === 'bottom-inset'}]" @click="borderTypeChoosen('bottom-inset')" uk-tooltip="title: Add border <u>on</u> bottom of image; pos: right; delay: 400;">
                            <div class="four-px-padding">
                                <img src="/img/illustrations/border_types/border-bottom-inset.svg" width="70px">
                            </div>
                            </a>
                            <a :class="['border-type', {'file-type-active': this.borderType === 'top-inset'}]" @click="borderTypeChoosen('top-inset')" uk-tooltip="title: Add border <u>on</u> top of image; pos: right; delay: 400;">
                            <div class="four-px-padding">
                                <img src="/img/illustrations/border_types/border-top-inset.svg" width="70px">
                            </div>
                            </a>
                            <a :class="['border-type', {'file-type-active': this.borderType === 'meme'}]" @click="borderTypeChoosen('meme')"  uk-tooltip="title:MEME: NOT EVERYONE WAS KUNG FU FIGHTING, MOM. SOME OF US WERE TRYING TO BREAK IT UP.; pos: right; delay: 400;">
                            <div class="four-px-padding">
                                <img src="/img/illustrations/border_types/border-meme.svg" width="70px">
                            </div>
                            </a>              
                        </div>
                        <div>
                            <p class="uk-text-muted uk-text-small uk-margin-remove uk-text-left">
                                <span><a @click="borderTypeChoosen(null)" class="uk-link-muted">reset</a></span>
                                <span class="uk-float-right uk-margin-remove"><i>{{this.borderType}}</i></span>
                            </p>
                        </div>


                        <!-- Inset Opacity Slider -->
                        <div v-if="['bottom-inset', 'top-inset', 'meme'].indexOf(borderType) >= 0" class="uk-margin uk-animation-slide-top-small">
                            <div class="uk-grid">
                                <label class="uk-width-expand uk-form-label"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">opacity</i> Opacity</label>
                                <label class="uk-form-label uk-padding-remove">{{this.$parent.borderOpacitySlider}}%</label>
                            </div>
                            <div class="uk-width-auto uk-margin-auto-vertical">
                                <vue-slider v-model="$parent.borderOpacitySlider" :min='0' :max='100' :tooltip="'none'"></vue-slider>
                            </div>
                        </div>  

                        <!-- Border Size Slider -->
                        <div class="uk-margin" style="padding-bottom: 3px;">
                            <label class="uk-form-label" for="form-stacked-text"><i class="material-icons uk-inline uk-text-top" style="font-size: 22px;">unfold_more</i> Border Size:</label>
                            <vue-slider v-model="$parent.borderSizeSlider.value" :tooltip="'none'"></vue-slider>
                        </div>   

                        <!-- Border Color Swatch -->
                        <div class="uk-margin">
                            <label class="uk-form-label" for="form-stacked-text">Choose Border Color:</label>
                            <compact-picker v-model="$parent.borderColor"/>
                        </div>                        
                    </div>
                </li>
                <li class="uk-open">
                    <a class="uk-accordion-title uk-text-muted" href="#">Add Text</a>
                    <div class="uk-accordion-content">                                                                       

                        <!-- Border Text Top -->
                        <div class="uk-margin" style="padding-bottom: 3px;">
                            <label class="uk-form-label" for="form-stacked-text">Text Top:</label>                  
                            <div class="uk-form-controls">
                                <input class="uk-input uk-form-small" autocomplete="off" v-model="$parent.borderTextTop" type="text" placeholder="Type...">
                            </div>
                        </div>   

                        <!-- Border Text Bottom -->
                        <div class="uk-margin" style="padding-bottom: 3px;">
                            <label class="uk-form-label" for="form-stacked-text">Text Bottom:</label>                  
                            <div class="uk-form-controls">
                                <input class="uk-input uk-form-small" autocomplete="off" v-model="$parent.borderTextBottom" type="text" placeholder="Type...">
                            </div>
                        </div>                  

                        <!-- Font Size Slider -->
                        <div class="uk-grid">
                            <label class="uk-width-expand uk-form-label">Font Size:</label>
                            <label class="uk-form-label uk-padding-remove">{{$parent.borderFontSizeSlider.value}}</label>
                        </div>
                        <div class="uk-width-auto uk-margin-auto-vertical">
                            <vue-slider v-bind="$parent.borderFontSizeSlider" v-model="$parent.borderFontSizeSlider.value"></vue-slider>
                        </div>                

                        <!-- Text Position  -->  
                        <div class="uk-margin">                  
                            <table class="uk-table uk-table-small uk-text-small uk-text-center uk-margin-remove">
                                <tbody>
                                    <tr>
                                        <td :class="[{'text-pos-active': this.$parent.borderTextPosition === 'left'}]" @click="$parent.borderTextPosition = 'left'"><i class="material-icons uk-inline">format_align_left</i></td>
                                        <td :class="[{'text-pos-active': this.$parent.borderTextPosition === 'center'}]" @click="$parent.borderTextPosition = 'center'"><i class="material-icons uk-inline">format_align_center</i></td>
                                        <td :class="[{'text-pos-active': this.$parent.borderTextPosition === 'right'}]" @click="$parent.borderTextPosition = 'right'"><i class="material-icons uk-inline">format_align_right</i></td>
                                    </tr>
                                </tbody>
                            </table>  
                        </div>

                        <!-- Text Font Disclaimer -->
                        <div class="uk-margin uk-text-center text-info-box">     
                            <label class="uk-form-label" for="form-stacked-text"><b>Font</b> and <b>Font Color</b>:</label>                                    
                            <div class='uk-text-small uk-padding-small'>
                                <i class="uk-text-muted">Click the text on the canvas to open font properties.</i>
                            </div> 
                        </div>
                    </div>   
                </li> 
            </ul>           
        </form>         
    </div>

  </div>

</template>

<script>
    import { Compact } from 'vue-color'

    export default {
        name: 'sidebar-design',
        components: {
            'compact-picker': Compact
        },
        data() {
            return {   
                borderType: ''
            }
        },
        methods: {
            borderTypeChoosen(type) {
                this.borderType = type
                this.$parent.addBorder(type)
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .header {
        border-bottom: 2px solid #F24C4E;
        margin-bottom: 10px;
        margin-top: 50px;  
        text-align: left;
        font-size: 18px;
    }

    .vc-compact {
        width: 180px !important;
    }

    .padding-small {
        padding: 12px;
    }

    .back-button {
        position: absolute;
        top: 10px;
        left: 10px;
    }

    .border-type {
        background: rgb(250, 250, 250);
        border-bottom: 2px solid transparent;
    }

    .border-type:hover {
        background: rgb(250, 250, 250);
        border-bottom: 2px solid #EAB126;
    }

    .file-type-active {        
        background: white;
        outline: 2px solid #11bb77;
        outline-offset: -2px;
        pointer-events: none;
    }

    .uk-button-white:hover {
        background: white;
        box-shadow: 0 0 0 1px rgba(50,50,93,.1), 0 2px 5px 0 rgba(50,50,93,.1), 0 3px 9px 0 rgba(50,50,93,.08), 0 1px 1.5px 0 rgba(0,0,0,.08), 0 1px 2px 0 rgba(0,0,0,.08); 
    }

    .uk-card-active {
        outline: 2px solid #28a5f5;
    }

    .uk-placeholder {
        border: none;
    }

    .uk-panel .uk-padding-small {
        padding: 8px 10px 8px 10px;
    }

    a {
        text-decoration: none;
    }

    td {
        user-select: none;
    }

    td:hover {
        background: #E4E4E4;
        cursor: pointer;
    }   

    .text-pos-active {
        background: #E4E4E4;
    }  

    .text-info-box {
        border-radius: 6px;
        border: 1px solid lightgray;
    }

    .four-px-padding {
        padding: 4px;
    }
</style>